import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { TopicTask } from "../../taskbook.types";
import { GifPreview, LinkPreview } from "@teammood/timeline";

@Component({
    selector: 'topic-task',
    templateUrl: './topic-task.component.html',
    styleUrls: ['./../task.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TopicTaskComponent {

    @Input() task: TopicTask
    @Output() onComment = new EventEmitter()
    @Output() onReported = new EventEmitter()

    constructor(){}

    toGifPreview(linkPreview: LinkPreview): GifPreview {
        return new GifPreview((linkPreview));
    }

    comment(){
        this.onComment.emit('');
    }

    achive(){
        this.task = undefined
    }

    reportItem(){
        this.onReported.emit();
    }
    
}